import styles from "./UserProfileSection.module.css"

function UserProfileSection({ title, description, children }) {
    return (
        <div className={styles.section}>
            <div className={styles.sectionHeader}>
                <h2 className={styles.sectionTitle}>{title}</h2>
                {description && <p className={styles.sectionDesc}>{description}</p>}
            </div>
            <div className={styles.sectionBody}>{children}</div>
        </div>
    );
}

export default UserProfileSection;